import {
  selectActiveTemplate,
  selectIsFinished,
  selectIsLoaded,
  selectIsLoading,
  selectIsProcessed,
  selectLoadedTemplates,
  selectProcess,
  selectTemplates,
  selectTournamentIdLoadedTemplate,
} from '../../store/templates/selectors';

import { useSelector } from 'react-redux';

function useTemplates() {
  const templates = useSelector(selectTemplates);
  const activeTemplate = useSelector(selectActiveTemplate);
  const isLoading = useSelector(selectIsLoading);
  const isLoaded = useSelector(selectIsLoaded);
  const isProcessed = useSelector(selectIsProcessed);
  const isFinished = useSelector(selectIsFinished);
  const currentProcess = useSelector(selectProcess);
  const tournamentId = useSelector(selectTournamentIdLoadedTemplate);
  const loadedTemplates = useSelector(selectLoadedTemplates);

  return {
    templates,
    isLoading,
    isLoaded,
    isProcessed,
    isFinished,
    activeTemplate,
    currentProcess,
    tournamentId,
    loadedTemplates,
  };
}

export default useTemplates;
